import { render, staticRenderFns } from "./EchartArea.vue?vue&type=template&id=0537bb6d&"
import script from "./EchartArea.vue?vue&type=script&lang=js&"
export * from "./EchartArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports